// ACTIONS
import {
  EVENT_TYPES_FETCHED,
  SUBSCRIPTION_REQUEST_STARTED,
  SUBSCRIPTION_FETCHED,
  SUBSCRIPTION_REQUEST_ERROR,
  ALERTS_DETAIL_VIEW_OPEN,
} from '../actions/EventSubscriptionActions';

import {
  ALERTS_REQUEST_STARTED,
  ALERTS_FETCHED,
  ALERTS_REQUEST_ERROR,
  ALERTS_COUNT_REQUEST_STARTED,
  ALERTS_COUNT_FETCHED,
  ALERTS_COUNT_REQUEST_ERROR,
  ALERTS_DETAILS_UPDATED,
  ALERTS_DETAILS_RESET,
} from '../actions/AlertsActions';

// Structure of loadedAlertsJson
// const loadedAlertsJson = {
//     alertsSearchCriterias: {},
//     columnsSort: { occurred_date: 'descending' },
//     countTotalAlerts: 0,
//     eventTypesSelected: [],
//     loadedAlerts: [],
//     next_page_id: null,
//     pageIndex: 0,
//     isCheckedAll: false,
//     selectedAlerts: [],
// };

const getInitialLoadedAlertsJson = () => {
  return {
    columnsSort: { occurred_date: 'descending' },
    eventTypesSelected: [],
    isCheckedAll: false,
    selectedAlerts: [],
  };
};

const getInitialState = () => {
  return {
    // Alert Types
    eventTypes: [],
    // Subscription
    subscription: null,
    LoadingSubscription: false,
    ErrorLoadingSubscription: false,
    // Alerts
    detailViewOpen: false,
    loadedAlertsJson: getInitialLoadedAlertsJson(),
    LoadingAlerts: false,
    ErrorLoadingAlerts: false,
    isFirstPageAlertsFetching: true,
  };
};

function EventSubscriptionState(state = getInitialState(), action) {
  let _loadedAlertsJson = null;
  switch (action.type) {
    case EVENT_TYPES_FETCHED:
      return {
        ...state,
        eventTypes: action.eventtypes.event_types,
      };

    case SUBSCRIPTION_REQUEST_STARTED:
      return {
        ...state,
        subscription: null,
        LoadingSubscription: true,
        ErrorLoadingSubscription: false,
      };

    case SUBSCRIPTION_FETCHED:
      return {
        ...state,
        subscription: action.subscription,
        LoadingSubscription: false,
        ErrorLoadingSubscription: false,
      };

    case SUBSCRIPTION_REQUEST_ERROR:
      return {
        ...state,
        subscription: null,
        LoadingSubscription: false,
        ErrorLoadingSubscription: true,
      };

    // Fetch alerts
    case ALERTS_REQUEST_STARTED:
      _loadedAlertsJson =
        action.muns && state.loadedAlertsJson && state.loadedAlertsJson.muns === action.muns
          ? state.loadedAlertsJson
          : getInitialLoadedAlertsJson();
      return {
        ...state,
        loadedAlertsJson: _loadedAlertsJson,
        LoadingAlerts: true,
        ErrorLoadingAlerts: false,
      };

    case ALERTS_FETCHED:
      /**
       * If pageIndex = 0, load the first page, then store the first page into the array loadedAlerts
       * If pageIndex > 0, load the next page, then join the previous page and the next page into the array loadedAlerts
       * countTotalAlerts: the total number of alerts for the selected subscription
       * loadedAlerts: the array of alerts was loaded for the selected subscription
       * Initialize the properties (key, checked), these properties support checking the checkbox and selecting the rows of alerts
       */
      _loadedAlertsJson = { ...state.loadedAlertsJson, ...action.loadedAlertsJson };
      if (action?.loadedAlertsJson?.items) {
        // set checked
        action?.loadedAlertsJson?.items.forEach((alertItem) => (alertItem.checked = false));
      }
      if (action?.loadedAlertsJson?.pageIndex > 0) {
        _loadedAlertsJson.loadedAlerts = [
          ..._loadedAlertsJson.loadedAlerts,
          ...action.loadedAlertsJson.items,
        ];
      } else {
        _loadedAlertsJson.countTotalAlerts = action.loadedAlertsJson.hits;
        _loadedAlertsJson.loadedAlerts = action.loadedAlertsJson.items;
      }
      // set key
      if (_loadedAlertsJson?.loadedAlerts) {
        _loadedAlertsJson.loadedAlerts.forEach((alertItem, index) => (alertItem.key = index));
      }
      return {
        ...state,
        loadedAlertsJson: _loadedAlertsJson,
        LoadingAlerts: false,
        ErrorLoadingAlerts: false,
        isFirstPageAlertsFetching: false,
      };

    case ALERTS_REQUEST_ERROR:
      return {
        ...state,
        loadedAlertsJson: null,
        LoadingAlerts: false,
        ErrorLoadingAlerts: true,
        isFirstPageAlertsFetching: false,
      };
    case ALERTS_DETAIL_VIEW_OPEN:
      return {
        ...state,
        detailViewOpen: action.open,
      };
    case ALERTS_COUNT_REQUEST_STARTED:
      return {
        ...state,
        alertsCount: 0,
        LoadingAlertsCount: true,
        ErrorLoadingAlertsCount: false,
      };
    case ALERTS_COUNT_FETCHED:
      return {
        ...state,
        alertsCount: action.alertsCount,
        LoadingAlertsCount: false,
        ErrorLoadingAlertsCount: false,
      };
    case ALERTS_COUNT_REQUEST_ERROR:
      return {
        ...state,
        alertsCount: 0,
        LoadingAlertsCount: false,
        ErrorLoadingAlertsCount: true,
      };
    case ALERTS_DETAILS_UPDATED:
      return {
        ...state,
        loadedAlertsJson: { ...state.loadedAlertsJson, ...action.alertsDetails },
      };
    case ALERTS_DETAILS_RESET:
      return {
        ...state,
        loadedAlertsJson: {
          ...state.loadedAlertsJson,
          ...{
            alertsSearchCriterias: null,
            columnsSort: { occurred_date: 'descending' },
            countTotalAlerts: 0,
            eventTypesSelected: [],
            loadedAlerts: [],
            next_page_id: null,
            pageIndex: 0,
            isCheckedAll: false,
            selectedAlerts: [],
          },
        },
        isFirstPageAlertsFetching: true,
      };
    default:
      return state;
  }
}

export default EventSubscriptionState;
